<template>
    <div class="engineering">
        <el-container>
            <el-header>
                <el-form class="engineeringForm" :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="queryBtn()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <!--                      <div style="padding-top: 16px;margin-top: 5px;">-->
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.importDetailedData.btnEnable"
                                    type="primary"
                                    @click="handleShowDataUploadDialogClick()"
                            >细目数据导入</el-button>
                            <el-button
                                    v-if="btnAuthorize.deleteDetailedData.btnEnable"
                                    type="primary"
                                    @click="handleSelectDeleteClick()"
                            >删除总包细目</el-button>
                            <el-button
                                    v-if="btnAuthorize.batchSubApproval.btnEnable"
                                    type="primary"
                                    @click="handleSelectSubmitClick()"
                            >批量提交审批</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                            <el-button
                                    v-if="btnAuthorize.setTabHiddenVisible.btnEnable"
                                    type="primary"
                                    @click="setTabDialogBtn()"
                            >设置Tab显隐</el-button>
                            <!--                          <el-button-->
                            <!--                                  v-if="btnAuthorize.allSave.btnEnable"-->
                            <!--                                  style="margin-top: 10px;margin-left: 0px"-->
                            <!--                                  type="primary"-->
                            <!--                                  @click="handleAllSaveClick()"-->
                            <!--                          >批量暂存</el-button>-->
                        </div>
                    </el-col>
                  <el-col :span="24">
                    <div class="operatePanel">
                      <div class="statisticsList" v-if="listTotal">
                        <div class="statisticsItem">
                          <div class="statisticsTxt">合同合计</div>
                          <div class="statisticsNum">{{listTotal.contractSumPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">核实合计</div>
                          <div class="statisticsNum">{{listTotal.checkSumPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">目标成本合计</div>
                          <div class="statisticsNum">{{listTotal.expectCostPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">目标-劳务</div>
                          <div class="statisticsNum">{{listTotal.laborPlanSumPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">目标-材料</div>
                          <div class="statisticsNum">{{listTotal.materialPlanSumPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">目标-机械</div>
                          <div class="statisticsNum">{{listTotal.machinePlanSumPrice}}</div>
                        </div>
                        <div class="statisticsItem">
                          <div class="statisticsTxt">目标-其他</div>
                          <div class="statisticsNum">{{listTotal.otherPlanSumPrice}}</div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        v-loading="loading"
                        element-loading-background="transparent"
                        class="bueatyScroll"
                        ref="dataTable"
                        :data="engineerList"
                        :span-method="spanArrayMethod"
                        @select="selectCheckOne"
                        @select-all="selectAll"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column :fixed="true" label="细目信息（总包）" width="160px"
                                     :show-overflow-tooltip="true">
                        <el-table-column fixed="left" width="80px" prop="subCategoryName" label="细目名称"></el-table-column>
                        <el-table-column fixed="left" width="80px" prop="subCategoryNo" label="细目号"
                                         :show-overflow-tooltip="true"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="projectName" label="清单（总包）" v-if="selectTabList.indexOf(1) != -1"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="deptName" label="价格" v-if="selectTabList.indexOf(2) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="单位" prop="unit" width="150px" v-if="selectTabList.indexOf(3) != -1">
                              <template slot-scope="scope">
                                <el-input size="mini" v-model="scope.row.unit" @blur="setValue(scope.row,1)"></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="单价" prop="unitPrice" width="150px" v-if="selectTabList.indexOf(4) != -1">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.unitPrice" @blur="setValue(scope.row,1)"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合同" v-if="selectTabList.indexOf(5) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="合同数量" width="150px" prop="contractCount" v-if="selectTabList.indexOf(6) != -1">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.contractCount" @blur="setValue(scope.row,1)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contractSumPrice" label="合同合价" v-if="selectTabList.indexOf(7) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="核实" v-if="selectTabList.indexOf(8) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="核实数量" width="150px" prop="checkCount" v-if="selectTabList.indexOf(9) != -1">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.checkCount" @blur="setValue(scope.row,1)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="checkSumPrice" label="核实合价" v-if="selectTabList.indexOf(10) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="目标成本" v-if="selectTabList.indexOf(11) != -1"
                                     :show-overflow-tooltip="true">
                        <el-table-column label="劳务" v-if="selectTabList.indexOf(12) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="laborItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(13) != -1"
                                             width="150px"></el-table-column>
                            <el-table-column prop="laborItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(14) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(15) != -1">
                              <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                <el-input size="mini" v-model="scope.row.laborItem_unit" @blur="setValue(scope.row,2)"></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" v-if="selectTabList.indexOf(16) != -1">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unitPrice" @blur="setValue(scope.row,2)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(17) != -1">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unitCount" @blur="setValue(scope.row,2)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(18) != -1">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_remark" @blur="setValue(scope.row,2)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laborItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(19) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="材料" v-if="selectTabList.indexOf(20) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="materialItem_productName" label="存货名称" v-if="selectTabList.indexOf(21) != -1"
                                             width="150px"></el-table-column>
                            <el-table-column prop="materialItem_productNumber" label="存货编码" v-if="selectTabList.indexOf(22) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(23) != -1">
                              <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                <el-input size="mini" v-model="scope.row.materialItem_unit" @blur="setValue(scope.row,3)"></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column prop="materialItem_model" label="规格型号" v-if="selectTabList.indexOf(24) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px" v-if="selectTabList.indexOf(25) != -1">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unitPrice" @blur="setValue(scope.row,3)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(26) != -1">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unitCount" @blur="setValue(scope.row,3)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(27) != -1">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_remark" @blur="setValue(scope.row,3)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(28) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="机械" v-if="selectTabList.indexOf(29) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="machineItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(30) != -1"
                                             width="150px"></el-table-column>
                            <el-table-column prop="machineItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(31) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(32) != -1">
                              <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                <el-input size="mini" v-model="scope.row.machineItem_unit" @blur="setValue(scope.row,4)"></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" v-if="selectTabList.indexOf(33) != -1">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unitPrice" @blur="setValue(scope.row,4)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(34) != -1">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unitCount" @blur="setValue(scope.row,4)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(35) != -1">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_remark" @blur="setValue(scope.row,4)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="machineItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(36) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="其他" v-if="selectTabList.indexOf(37) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="otherItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(38) != -1"
                                             width="150px"></el-table-column>
                            <el-table-column prop="otherItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(39) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="otherItem_unit" label="单位" width="150px" v-if="selectTabList.indexOf(40) != -1">
                              <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                <el-input size="mini" v-model="scope.row.otherItem_unit" @blur="setValue(scope.row,5)"></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" v-if="selectTabList.indexOf(41) != -1">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unitPrice" @blur="setValue(scope.row,5)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(42) != -1">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unitCount" @blur="setValue(scope.row,5)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(43) != -1">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_remark" @blur="setValue(scope.row,5)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="otherItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(44) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合计" v-if="selectTabList.indexOf(45) != -1"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="unit_Price" label="单价" v-if="selectTabList.indexOf(46) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="total_Price" label="合计" v-if="selectTabList.indexOf(47) != -1"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="approveStatusDisplayName" label="审核状态" v-if="selectTabList.indexOf(48) != -1"
                                     :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作" prop="operation" fixed="right" min-width="200px">
                        <template slot-scope="scope">
                            <el-button @click="handleAddBillClick(scope.row)" type="text" size="small">新增工程量清单</el-button>
                            <el-button @click="handleAddDetailClick(scope.row)" type="text" size="small">新增细目</el-button>
                            <el-button @click="handleDeleteClick(scope.row)" type="text" size="small">删除细目</el-button>
<!--                            <el-button @click="handleSaveClick(scope.row)" type="text" size="small">暂存</el-button>-->
                            <el-button @click="handleSubmitClick(scope.row)" type="text" size="small">提交审核</el-button>
                            <el-button @click="handleWithdrawClick(scope.row)" type="text" size="small">撤回</el-button>
                            <el-button @click="handleHistoryEditionClick(scope.row)" type="text" size="small">历史版本</el-button>
                            <el-button @click="handleInfoDetailsClick(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>

        <add-detail v-if="addVisible" ref="addDetail" @refreshDataList="initData"></add-detail>
        <add-bill v-if="addBillVisible" ref="addBillDetail" @refreshDataList="initData"></add-bill>
        <submit-review v-if="submitVisible" ref="submitReview" @refreshDataList="initData"></submit-review>
        <all-submit-review v-if="allSubmitVisible" ref="allSubmitReview" @refreshDataList="initData"></all-submit-review>
        <tab-show-dialog v-if="isShowTabDialog" ref="tabShowDialog" :title="'事前Tab显隐'" @setSelectTabList="setSelectTabList"></tab-show-dialog>
        <data-upload-dialog v-if="isShowDataUploadDialog" ref="dataUploadDialog" @refreshDataList="uploadData"></data-upload-dialog>
    </div>
</template>

<script>
    import { beforeSpanMethod,getJBXXTableData } from '../spanMethod';
    import { ModifyValue } from '../modifyValue';
    import addDetail from './add-detail'
    import addBill from './add-bill'
    import submitReview from '../submit-review'
    import allSubmitReview from '../all-submit-review'
    import tabShowDialog from '../tabShowDialog'
    import dataUploadDialog from './data-upload-dialog'
    import {
        getProjectListService,
    } from '@/services/invoiceServices'
    import {
      getDeptListService,
      getBefireListService,
      saveFrontService,
      saveFrontBatchService,
      recallApproveProcessService,
      queryBeforeListTotalService,
      frontExportService,
        batchDeleteFrontDataService,
    } from '../../../services/engineering'
    import {exportExcelService2} from "../../../services/allContractServices";
    import { Loading } from 'element-ui';
    export default {
        name: "index",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                tabDataList:[{
                    label: '事前成本',
                    id: 0,
                    children:[
                        {
                            label: '清单（总包）',
                            id: 1,
                            children: [
                                {
                                    label: '价格',
                                    id: 2,
                                    children: [{
                                        label: '单位',
                                        id: 3,
                                    },{
                                        label: '单价',
                                        id: 4,
                                    },]
                                },{
                                    label: '合同',
                                    id: 5,
                                    children: [{
                                        label: '合同数量',
                                        id: 6,
                                    },{
                                        label: '合同合价',
                                        id: 7,
                                    },]
                                },{
                                    label: '核实',
                                    id: 8,
                                    children: [{
                                        label: '核实数量',
                                        id: 9,
                                    },{
                                        label: '核实合价',
                                        id: 10,
                                    },]
                                }
                            ],
                        },{
                            label: '目标成本',
                            id: 11,
                            children: [
                                {
                                    label: '劳务',
                                    id: 12,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 13,
                                        },{
                                            label: '细目号',
                                            id: 14,
                                        },{
                                            label: '单位',
                                            id: 15,
                                        },{
                                            label: '单价',
                                            id: 16,
                                        },{
                                            label: '数量',
                                            id: 17,
                                        },{
                                            label: '备注',
                                            id: 18,
                                        },{
                                            label: '合价',
                                            id: 19,
                                        }
                                    ]
                                },{
                                    label: '材料',
                                    id: 20,
                                    children: [
                                        {
                                            label: '存货名称',
                                            id: 21,
                                        },{
                                            label: '存货编码',
                                            id: 22,
                                        },{
                                            label: '单位',
                                            id: 23,
                                        },{
                                            label: '规格型号',
                                            id: 24,
                                        },{
                                            label: '单价',
                                            id: 25,
                                        },{
                                            label: '数量',
                                            id: 26,
                                        },{
                                            label: '备注',
                                            id: 27,
                                        },{
                                            label: '合价',
                                            id: 28,
                                        }
                                    ]
                                },{
                                    label: '机械',
                                    id: 29,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 30,
                                        },{
                                            label: '细目号',
                                            id: 31,
                                        },{
                                            label: '单位',
                                            id: 32,
                                        },{
                                            label: '单价',
                                            id: 33,
                                        },{
                                            label: '数量',
                                            id: 34,
                                        },{
                                            label: '备注',
                                            id: 35,
                                        },{
                                            label: '合价',
                                            id: 36,
                                        }
                                    ]
                                },{
                                    label: '其他',
                                    id: 37,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 38,
                                        },{
                                            label: '细目号',
                                            id: 39,
                                        },{
                                            label: '单位',
                                            id: 40,
                                        },{
                                            label: '单价',
                                            id: 41,
                                        },{
                                            label: '数量',
                                            id: 42,
                                        },{
                                            label: '备注',
                                            id: 43,
                                        },{
                                            label: '合价',
                                            id: 44,
                                        }
                                    ]
                                },{
                                    label: '合计',
                                    id: 45,
                                    children: [
                                        {
                                            label: '单价',
                                            id: 46,
                                        },{
                                            label: '合计',
                                            id: 47,
                                        }
                                    ]
                                }
                            ],
                        },{
                            label: '审核状态',
                            id: 48,
                        }
                    ]
                }],
                selectTabList: [],
                isShowTabDialog: false,
                total:0,
                listTotal: null,

                deptList:[], //项目部列表
                projectList:[], //项目列表

                engineerList:[],
                actualEngineerList: [],
                addVisible: false,
                isFirst: true,
                addBillVisible: false,
                submitVisible: false,
                allSubmitVisible: false,
                btnAuthorize: {
                    export: { key: "export", btnEnable: false },
                    batchSubApproval: { key: "batchSubApproval", btnEnable: false },
                    setTabHiddenVisible: { key: "setTabHiddenVisible", btnEnable: false },
                    deleteDetailedData: { key: "deleteDetailedData", btnEnable: false },
                    importDetailedData: { key: "importDetailedData", btnEnable: false },
                },
                multipleSelection: [],
                loading: false,

                isShowDataUploadDialog: false,
            }
        },
        components:{
            addDetail,
            addBill,
            submitReview,
            allSubmitReview,
            tabShowDialog,
            dataUploadDialog,
        },
        methods: {
            onActive(menuCode) {
                let selectTabList = []
                for (let i = 0; i<49; i++){
                    selectTabList.push(i)
                }
                this.selectTabList = selectTabList
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getDeptList();
                if(this.dataForm.projectId){
                    this.initData();
                }
            },
            queryBtn(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                this.dataForm.pageIndex = 1;
                this.initData();
            },
            initData(){
              if(!this.dataForm.projectId){
                this.$message.error('请选择项目名称');
                return
              }
              this.loading = true;
              this.query();
              this.getBeforeListTotal();
            },
            getBeforeListTotal(){
              let paramsData = {
                ...this.dataForm
              }
              queryBeforeListTotalService(paramsData).then( res => {
                if(res.code == 10000000){
                  this.listTotal = res.data;
                }else{
                  this.$message.error(res.msg);
                }
              }).catch(error => {
                this.$message.error("网络请求失败");
              });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询列表数据
             * */
            query(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                let paramsData = {
                    ...this.dataForm
                }
                getBefireListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.multipleSelection = [];
                        this.actualEngineerList = res.data;
                        this.engineerList =  beforeSpanMethod(res.data)
                        this.total = res.total;
                        this.$forceUpdate();
                        this.$nextTick(()=>{
                          this.loading = false;
                        })
                        // if(this.isFirst){
                        //     this.$nextTick(()=> {
                        //         this.childHeight4 = this.$refs.dataTable.$el.childNodes[4].offsetHeight - 12 + 'px';
                        //         this.childHeight5 = this.$refs.dataTable.$el.childNodes[5].offsetHeight - 6 + 'px';
                        //         this.$refs.dataTable.$el.childNodes[4].style.height = this.childHeight4
                        //         this.$refs.dataTable.$el.childNodes[5].style.height = this.childHeight5
                        //         this.$refs.dataTable.$el.childNodes[5].style.top = '-6px'
                        //         this.$refs.dataTable.$el.childNodes[5].style.zIndex = '0'
                        //         this.isFirst = false;
                        //     })
                        // }else {
                        //   this.$refs.dataTable.$el.childNodes[4].style.height = this.childHeight4
                        //   this.$refs.dataTable.$el.childNodes[5].style.height = this.childHeight5
                        //   this.$refs.dataTable.$el.childNodes[5].style.top = '-6px'
                        //   this.$refs.dataTable.$el.childNodes[5].style.zIndex = '0'
                        // }
                    }else{
                        this.$message.error(res.msg);
                        this.loading = false;
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                    this.loading = false;
                });
            },
            /**
             * 重置列表数据
             * */
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.total = 0;
                this.engineerList = [];
                this.listTotal = null;
                this.projectList = [];
            },
            //设置数值
            setValue(item,type){
                if(item.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                this.actualEngineerList =  ModifyValue(this.actualEngineerList, item, type)
                this.engineerList =  beforeSpanMethod(this.actualEngineerList)
                this.$nextTick(()=> {
                  this.loading = true;
                  this.handleSaveClick(item, 5)
                })
            },
            //新增工程量清单
            handleAddBillClick(item){
                if(item.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                this.addBillVisible = true
                this.$nextTick(() => {
                    this.$refs.addBillDetail.projectId = this.dataForm.projectId;
                    this.$refs.addBillDetail.init()
                })
            },
            //选中的值
            // handleSelectionChange(val) {
            //   console.log(val)
            //     this.multipleSelection = val;
            // },
            selectCheckOne(val, row) {
              //isSelect true为选中 false 为取消
              let isSelect = val.length && val.indexOf(row) > -1
              //findIndex返回-1则不存在，>0则存在
              let n = this.multipleSelection.findIndex(v => {
                return v.id == row.id
              })
              if (isSelect) {
                if (n < 0) this.multipleSelection.push(row)
              } else {
                if (n > -1) this.multipleSelection = this.multipleSelection.filter(function (obj) {
                  return obj.id !== row.id;
                });
              }
            },
            //全选
            selectAll(arr) {
              //全选先把所有id拿到并去重
              let _arr = [...new Set(arr)]
              this.multipleSelection = _arr
            },
            //新增细目
            handleAddDetailClick(item){
                if(item.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                this.handleSaveClick(item,1)
                // this.addVisible = true
                // this.$nextTick(() => {
                //     this.$refs.addDetail.id = item.id;
                //     this.$refs.addDetail.init()
                // })
            },
            handleSubmitClick(item){
                if(item.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                this.submitVisible = true
                this.$nextTick(() => {
                    this.$refs.submitReview.id = item.id;
                    this.$refs.submitReview.row = item;
                    this.$refs.submitReview.actualEngineerList = this.actualEngineerList;
                    this.$refs.submitReview.title = item.subCategoryName;
                    this.$refs.submitReview.documentNum = item.subCategoryNo;
                    this.$refs.submitReview.projectId = this.dataForm.projectId;
                    this.$refs.submitReview.init();
                })
            },
            // 批量删除总包细目
            handleSelectDeleteClick(){
                if(this.multipleSelection.length == 0){
                    this.$message.error('请选择要删除的数据');
                    return
                }
                console.log(this.multipleSelection)
                let index = this.multipleSelection.findIndex(item => item.approveStatusDisplayName == '待审核' || item.approveStatusDisplayName == '已通过')
                console.log(index)
                if(index != -1){
                  this.$message.error('事前成本已开始审批，不允许删除');
                  return
                }
                this.$confirm('此操作将永久删除该总包细目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = this.multipleSelection.map(item => item.id)
                    let params = {
                        ids: ids
                    }
                    batchDeleteFrontDataService(params).then(res => {
                        if(res.code == 10000000){
                            this.$message.success('删除成功');
                            this.initData();
                        }
                    })
                }).catch(() => {

                });
            },
            // 批量提交审批
            handleSelectSubmitClick(){
              if(this.multipleSelection.length == 0){
                  this.$message.error('请选择要提交的数据');
                  return
                }
                let index = this.multipleSelection.findIndex(item => item.approveStatusDisplayName == '待审核')
                if(index != -1){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                // this.handleAllSaveClick(true);
                this.allSubmitVisible = true
                this.$nextTick(() => {
                    this.$refs.allSubmitReview.approveItemList = this.multipleSelection;
                    this.$refs.allSubmitReview.actualEngineerList = this.actualEngineerList;
                    this.$refs.allSubmitReview.projectId = this.dataForm.projectId;
                    this.$refs.allSubmitReview.init();
                })
            },
            handleWithdrawClick(item){
                this.$confirm("确定要撤回吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {
                        itemId : item.id,
                        type: 'PROJECT_FRONT'
                    }
                    recallApproveProcessService(params).then( res => {
                        if(res.code == 10000000){
                            this.$message.success('撤回成功');
                            this.initData();
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        this.$message.error("网络请求失败");
                    });
                });
            },
            handleDeleteClick(row){
                if(row.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                this.handleSaveClick(row,2)
                // this.bus.$emit("navMenuChange", {
                //     routeId: "beforDeleteDetail",
                //     routeParam: {
                //         id: row.generalContractProjectDetailsId
                //     }
                // });
            },
            handleSaveClick(row, noMessage=false){
                if(row.approveStatusDisplayName == '待审核'){
                    this.$message.error('事前成本已开始审批，不允许更新');
                    return
                }
                let  params = this.actualEngineerList[row.index]
                params.approveStatusEnum = 'READY'
                saveFrontService(params).then( res => {
                    if(res.code == 10000000){
                        if(!noMessage){
                            this.$message.success('暂存成功');
                            this.initData();
                        }else{
                            if (noMessage == 1) {
                                this.addVisible = true
                                this.$nextTick(() => {
                                    this.$refs.addDetail.id = row.id;
                                    this.$refs.addDetail.init()
                                })
                            }else if (noMessage == 2){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "beforDeleteDetail",
                                    routeParam: {
                                        id: row.id,
                                        isShowDeleteBtn : this.btnAuthorize.deleteDetailedData.btnEnable
                                    }
                                });
                            }else if (noMessage == 3){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "beforInfoDetails",
                                    routeParam: {
                                        id: row.id,
                                        index: 1
                                    }
                                });
                            }else if (noMessage == 4){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "beforHistoryEdition",
                                    routeParam: {
                                        id: row.generalContractProjectDetailsId
                                    }
                                });
                            }else if (noMessage == 5){
                                this.initData();
                            }
                        }
                    }else{
                        if(!noMessage){
                          this.$message.error(res.msg);
                        }
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            handleAllSaveClick(noMessage = false){
                let  params = [];
                this.actualEngineerList.map(item => {
                    if(item.approveStatusDisplayName != '待审核'){
                        item.approveStatusEnum = 'READY'
                        params.push(item)
                    }
                })
                saveFrontBatchService(params).then( res => {
                    if(res.code == 10000000){
                        if(!noMessage){
                            this.$message.success('批量暂存成功（仅对已保存状态和撤回状态的数据暂存）');
                            this.initData();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            handleInfoDetailsClick(row){
                if(row.approveStatusDisplayName == '待审核'){
                    this.bus.$emit("navMenuChange", {
                        routeId: "beforInfoDetails",
                        routeParam: {
                            id: row.id,
                            index: 1
                        }
                    });
                }else{
                    this.handleSaveClick(row,3)
                }
            },
            handleHistoryEditionClick(row){
                if(row.approveStatusDisplayName == '待审核'){
                    this.bus.$emit("navMenuChange", {
                        routeId: "beforHistoryEdition",
                        routeParam: {
                            id: row.generalContractProjectDetailsId
                        }
                    });
                }else{
                    this.handleSaveClick(row,4)
                }
            },
            /***
             * 导出
             */
            exportBtn(){
                if(!this.dataForm.projectId){
                    this.$message.error('请先选择项目名称后再导出！');
                    return
                }
                let loading = Loading.service({
                    lock: true,
                    text: "加载中",
                    background: "rgba(0, 0, 0, 0.5)"
                });
                let params = {
                    ...this.dataForm
                }
                frontExportService(params).then( res => {
                    loading.close();
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    loading.close();
                    this.$message.error("网络请求失败");
                });
            },
            setTabDialogBtn(){
              this.isShowTabDialog = true;
              this.$nextTick(()=> {
                  this.$refs.tabShowDialog.tabDataList = this.tabDataList;
                  this.$refs.tabShowDialog.selectTabList = this.selectTabList;
                  this.$refs.tabShowDialog.init();
              })
            },
            setSelectTabList(val){
                console.log(val)
                this.selectTabList = val;
                this.isShowTabDialog = false;
                this.reset();
                this.$nextTick(() => {
                  this.$refs.dataTable.$el.childNodes[2].style.height = this.$refs.dataTable.$el.childNodes - ( this.$refs.dataTable.$el.childNodes[1].clientHeight || this.$refs.dataTable.$el.childNodes[1].offsetHeight) + 'px'
                  this.$refs.dataTable.doLayout()
                })
            },
            findmissingNumber(nums){
                const stk=[];
                for(let i=1;i<49;i++){
                    if(!nums.includes(i)){
                        stk.push(i);
                    }
                }
                return stk;
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.initData();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.initData();
            },
            //合并表格条件
            spanArrayMethod({row,column,rowIndex,columnIndex}) {
                if (column.type == 'selection'||column.property == 'subCategoryName'||column.property == 'subCategoryNo'||column.property == 'unit'
                    ||column.property == 'unitPrice' ||column.property == 'contractCount' ||column.property == 'contractSumPrice' ||column.property == 'checkCount'
                    ||column.property == 'checkSumPrice' ||column.property == 'unit_Price' ||column.property == 'total_Price' ||column.property == 'approveStatusDisplayName'
                    ||column.property == 'operation') {
                    const _row = (getJBXXTableData(this.engineerList).one)[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
            },
            // 显示数据导入弹窗
            handleShowDataUploadDialogClick(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                this.isShowDataUploadDialog = true;
                this.$nextTick(() => {
                    this.$refs.dataUploadDialog.projectId = this.dataForm.projectId;
                    this.$refs.dataUploadDialog.init();
                })
            },
            uploadData(){
                this.isShowDataUploadDialog = false;
                this.queryBtn();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        /deep/.engineeringForm {
          .el-form-item{
            margin-top: 5px;
          }
        }
        .operatePanel{
          margin-top: 5px !important;
            .el-button{
                margin-bottom: 10px;
            }
        }
    }
    .statisticsList{
      display: flex;
      border: 1px solid #E6E6E6;
      .statisticsItem {
        width: 14.2857%;
        .statisticsTxt {
          width: 100%;
          height: 36px;
          line-height: 36px;
          text-align: center;
          border-right: 1px solid #E6E6E6;
          border-bottom: 1px solid #E6E6E6;
          font-size: 12px;
        }
        .statisticsNum {
          width: 100%;
          height: 36px;
          line-height: 36px;
          text-align: center;
          border-right: 1px solid #E6E6E6;
        }
      }
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
    /deep/.el-table{
        th>.cell{
            text-align: center;
        }
        .cell.el-tooltip{
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
        }
    }
    /deep/.bueatyScroll {
        .el-table__body-wrapper{
          height: calc(100% - 114px) !important;
        }
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-scrollbar__wrap::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-table__fixed{
            height: calc(100% - 12px) !important;
        }
        .el-table__fixed-right{
            height: calc(100% - 12px) !important;
        }
    }
</style>
